module.exports = __webpack_public_path__ + "img/Education.5ce8f1cd.jpg";